module.exports = __webpack_public_path__ + "fonts/firacode-medium.fbea5d0.eot";